<template>
  <section
    id="message"
    class="co-bg-striped"
  >
    <div class="co-container-md mx-auto px-5 py-20 lg:px-0">
      <h2 class="co-heading-2-caption">
        業務内容
      </h2>
      <h3 class="co-display-12 mb-[3.25rem] text-center leading-base">
        受講生をサポートするための3つの業務をご紹介
      </h3>
      <div class="mx-0 mb-10 flex flex-col bg-co-gray-50 shadow-[0_0_4px_rgba(51,51,51,0.2)] md:flex-row">
        <div class="basis-full md:basis-1/3">
          <img
            class="w-full"
            src="~/assets/images/Te/TeJob/Message/mentor-entry-work-1.jpg"
            loading="lazy"
            alt="マンツーマンメンタリング"
          >
        </div>
        <div class="flex flex-col justify-center p-5 md:basis-2/3">
          <h3 class="co-display-9 mb-4 text-center tracking-[.15em] md:text-left">
            マンツーマンメンタリング
          </h3>
          <p class="mb-0 tracking-[.15em]">
            <slot name="mentoringText">
              1回30分のビデオチャットで受講生からの相談や質問に答えていただきます。
              <br class="hidden md:block">
              マンツーマンメンタリングはカリキュラムやチャットで解決できなかった課題を確実に解消させる取り組みです。
            </slot>
          </p>
        </div>
      </div>
      <div class="mx-0 mb-10 flex flex-col bg-co-gray-50 shadow-[0_0_4px_rgba(51,51,51,0.2)] md:flex-row-reverse">
        <div class="basis-full md:basis-1/3">
          <img
            class="h-auto max-w-full"
            src="~/assets/images/Te/TeJob/Message/mentor-entry-work-2.jpg"
            loading="lazy"
            alt="チャットサポート"
          >
        </div>
        <div class="flex flex-col justify-center p-5 md:basis-2/3">
          <h3 class="co-display-9 mb-4 text-center tracking-[.15em] md:text-left">
            チャットサポート
          </h3>
          <p class="mb-0 tracking-[.15em]">
            <slot name="chatsupportText" />
            受講生の質問にチャットで対応していただきます。
            <br class="hidden md:block">
            素早くきめ細かな対応で受講生の「わからない」を解消します。
          </p>
        </div>
      </div>
      <div class="mx-0 flex flex-col bg-co-gray-50 shadow-[0_0_4px_rgba(51,51,51,0.2)] md:flex-row">
        <div class="basis-full md:basis-1/3">
          <img
            class="h-auto max-w-full"
            src="~/assets/images/Te/TeJob/Message/mentor-entry-work-3.jpg"
            loading="lazy"
            alt="課題レビュー"
          >
        </div>
        <div class="flex flex-col justify-center p-5 md:basis-2/3">
          <h3 class="co-display-9 mb-4 text-center tracking-[.15em] md:text-left">
            課題レビュー
          </h3>
          <p class="mb-0 tracking-[.15em]">
            <slot name="reviewText">
              カリキュラム内で出される課題のソースコードをレビューしていただきます。
              <br class="hidden md:block">
              受講生が正しいソースコードが書けるまで繰り返し徹底したサポートを行い、挫折させることなく確実にコーディングスキルを上げる取り組みです。
              <br class="hidden md:block">
              ソースコードを理解するための最適な手段となります。
            </slot>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
